import { getPriceBySellBand } from './getItemPriceBySellBand';

const sumPrice = (data, qty, sellBandId) => {
  let sumPrice = 0;

  if (!sellBandId) {
    data.prep_items = data?.prep_items ? data.prep_items : [];

    let sumPrepItem = data.prep_items.reduce((prev, curr) => {
      prev += curr.baseQuantity * curr.amount * (qty || 1);
      return prev;
    }, 0);

    return sumPrepItem;
  }

  data.group = data.group
    ? data?.group ? data.group : []
    : data?.prep_group ? data.prep_group : []

  let findPrepItem = data.group.reduce((prev, curr) => {
    if (curr.item && curr?.item?.length > 0) {
      prev.push(...curr.item);
    }
    if (curr.prep_item && curr?.prep_item?.length > 0) {
      prev.push(...curr.prep_item);
    }
    return prev;
  }, []);

  let sumPrepItem = 0;
  if (findPrepItem.length > 0) {
    findPrepItem.forEach((val) => {
      let getPrepItemPrice = getPriceBySellBand(val, sellBandId);

      if (val.checked && getPrepItemPrice > 0) {
        sumPrepItem += getPrepItemPrice * (val.quantity || 1);
      }
    });
  } 

  sumPrice += getPriceBySellBand(data, sellBandId);
  return (sumPrice  * (qty || 1) + sumPrepItem );
};

export const sumTotalPriceWithPrepItem = (data, qty, sellBandId) => {
  let getData = data;
  if (data.is_variant) {
    if (data.group.length > 0) {
      getData = data;
    } else {
      getData = data.variant_item.find((data) => data.checked);
    }
  }
  if (getData) {
    return sumPrice(getData, qty, sellBandId);
  }
  return 0;
};
